export enum ROUTE_SLUGS {
  ORG_ID = ":orgId",
  DEVICE_ID = ":deviceId",
  ARTICLE_ID = ":articleId",
  TEMPLATE_KEY = ":templateKey",
  DOC_ID = ":docId",
  FILE_ID = ":fileId",
  USER_ID = ":userId",
  TASK_ID = ":taskId",
  PROGRAM_ID = ":programId",
  TEMPLATE_ID = ":templateId",
  PLAN_ID = ":planId",
}

export enum ROUTES {
  CALLBACK = "/callback",
  DASHBOARD = `/${ROUTE_SLUGS.ORG_ID}/dashboard`,
  DEVICE_MANAGEMENT = `/${ROUTE_SLUGS.ORG_ID}/device-management`,
  DOCUMENTS = `/${ROUTE_SLUGS.ORG_ID}/documents`,
  ORGANIZATION_DOCUMENT = `/${ROUTE_SLUGS.ORG_ID}/documents/${ROUTE_SLUGS.DOC_ID}`,
  CHANGE_MANAGEMENT_PLANS = `/${ROUTE_SLUGS.ORG_ID}/change-management-plans`,
  CHANGE_MANAGEMENT_PLAN = `/${ROUTE_SLUGS.ORG_ID}/change-management-plans/${ROUTE_SLUGS.PLAN_ID}`,
  TRASH_DOCUMENT = `/${ROUTE_SLUGS.ORG_ID}/documents/trash/${ROUTE_SLUGS.DOC_ID}`,
  FRAME_VIEWER = `/${ROUTE_SLUGS.ORG_ID}/documents/frames/${ROUTE_SLUGS.TEMPLATE_ID}`,
  TASKS = `/${ROUTE_SLUGS.ORG_ID}/tasks`,
  SKILLS = `/${ROUTE_SLUGS.ORG_ID}/skills`,
  ORG_TASK_DETAIL = `/${ROUTE_SLUGS.ORG_ID}/task/${ROUTE_SLUGS.TASK_ID}`,
  DEVICE_TASKS = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/tasks`,
  TASK_DETAIL = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/task/${ROUTE_SLUGS.TASK_ID}`,
  DEVICE_OVERVIEW = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}`,
  ERROR = `/${ROUTE_SLUGS.ORG_ID}/error`,
  FORM = `/${ROUTE_SLUGS.ORG_ID}/form`,
  LOGIN = "/login",
  HELP_CENTER = `/help-center`,
  HELP_CENTER_ARTICLE = `/help-center/${ROUTE_SLUGS.ARTICLE_ID}`,
  QMS = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/documents`,
  TRACEABILITY_MATRIX = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/traceability-matrix`,
  QMS_OPEN_DOC = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/documents/${ROUTE_SLUGS.DOC_ID}`,
  SIGNUP = "/signup",
  // Legacy wizard URL, kept so existing links (e.g. from the traceability matrix) keep working.
  // The wizard only needs the document, so build new links with DOCUMENT_ASSISTANT.
  TEMPLATE_ASSISTANT = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/template-assistant/${ROUTE_SLUGS.TEMPLATE_KEY}/${ROUTE_SLUGS.DOC_ID}`,
  DOCUMENT_ASSISTANT = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/template-assistant/${ROUTE_SLUGS.DOC_ID}`,
  TEMPLATE_EDITOR = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/templates/${ROUTE_SLUGS.TEMPLATE_KEY}`,
  CHECKOUT_SUCCESS = `/${ROUTE_SLUGS.ORG_ID}/checkout/success`,
  MANAGE_ORGANIZATION = `/${ROUTE_SLUGS.ORG_ID}/settings`,
  ASSISTANT = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/assistant`,
  ASSISTANT_DU_CONFIGURE = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/assistant/document-update/configure`,
  ASSISTANT_DU_LIST_OF_DOCS_TO_CHANGE = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/assistant/document-update/to-change`,
  ASSISTANT_DU_MULTI_STEP_FORM = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/assistant/document-update/editing`,
  ASSISTANT_DU_GENERATING_DOCS = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/assistant/generating-documents`,
  ASSISTANT_DU_UPDATE_DOCS = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/assistant/document-for-update`,
  DEACTIVATED_USER = `/deactivated-user`,
  TERMINAL = `/${ROUTE_SLUGS.ORG_ID}/device/${ROUTE_SLUGS.DEVICE_ID}/terminal`,
  ECFR_PIN_RESET = "/ecfr-pin-reset",
  USER_SETTINGS = `/${ROUTE_SLUGS.ORG_ID}/me/settings`,
  ADMIN_TASK_DEFINITIONS = `/${ROUTE_SLUGS.ORG_ID}/admin/task-definitions`,
  ADMIN_ROADMAP_CARDS = `/${ROUTE_SLUGS.ORG_ID}/admin/roadmap-cards`,
  QUALITY_EVENTS = `/${ROUTE_SLUGS.ORG_ID}/quality-events`,
  QUALITY_EVENT_OVERVIEW = `/${ROUTE_SLUGS.ORG_ID}/quality-events/:qualityEventKey`,
  QUALITY_EVENT_RECORD = `/${ROUTE_SLUGS.ORG_ID}/quality-events/:qualityEventKey/:recordId`,
  TRAININGS = `/${ROUTE_SLUGS.ORG_ID}/trainings`,
  TRAINING_ASSIGN = `/${ROUTE_SLUGS.ORG_ID}/trainings/assign`,
  TRAINING_DETAIL = `/${ROUTE_SLUGS.ORG_ID}/trainings/${ROUTE_SLUGS.PROGRAM_ID}`,
  TRAINING_EDIT = `/${ROUTE_SLUGS.ORG_ID}/trainings/${ROUTE_SLUGS.PROGRAM_ID}/edit`,
  TRAINING_QUIZ_EDIT = `/${ROUTE_SLUGS.ORG_ID}/trainings/${ROUTE_SLUGS.PROGRAM_ID}/quiz`,
  OAUTH_CALLBACK = `/oauth-callback`,
}
